export const tableHeader = (t) => [
  { id: "entity_name", label: t('common:labels.name'), type: "name-description", nameKey: 'entity_name', descriptionKey: 'entity_description', sortable: true },
  { id: "entity_type", label: t('common:labels.type'), type: "type-entity", sortable: true },
  { id: "progresso", label: t('gap-analysis:table.progress'), type: "progress", sortable: true },
];
